import { render, staticRenderFns } from "./changelog-list.vue?vue&type=template&id=4dfee2aa"
import script from "./changelog-list.vue?vue&type=script&lang=js"
export * from "./changelog-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports